import React from 'react';
import { connect } from 'react-redux';
import { getTenantState } from '../../store/selectors';
import {
  getUsersByCampusCounts,
  getUsersByCampusCountsCsv,
} from '../../store/actions';
import { reportingCopy } from '../../copy/advisor-dashboard/advisor-dashboard-base.json';
import Loading from '../utility/Loading';
import UsersByCampusChart from './users-by-campus-components/UserByCampusChart';
import CSVDownloadMenu from './reporting-components/CSVDownloadMenu';

export class UsersByCampus extends React.Component {
  _isMounted = false;

  constructor(props) {
    super(props);
    this.state = {
      loading: true,
      data: {},
    };
    this.getData = this.getData.bind(this);
    this.getCsv = this.getCsv.bind(this);
  }

  async componentDidMount() {
    this.setState({ data: await this.getData(), loading: false });
  }

  async getData() {
    const data = await this.props.getUsersByCampusCounts(this.props.tenant.id);
    return data;
  }

  async getCsv() {
    const csvData = await this.props.getUsersByCampusCountsCsv(
      this.props.tenant.id
    );
    return csvData;
  }

  render() {
    return (
      <div
        className="highest-level-of-education"
        id="highest-level-of-education"
      >
        <div className="highest-level-of-education__header">
          <div className="highest-level-of-education__heading">
            {reportingCopy.usersByCampus?.heading ||
              'Users Registered by Campus'}
          </div>
          <div className="highest-level-of-education__meatball-menu-container">
            <CSVDownloadMenu csv={this.getCsv} filename="users-by-campus" />
          </div>
        </div>
        <div className="highest-level-of-education__subheading">
          {reportingCopy.usersByCampus?.subheading ||
            'The numbers below indicate the campus a user expressed interest in or was attending at the time of registering for me3. Please note that their campus may have changed since registration.'}
        </div>
        {this.state.loading ? (
          <Loading height="100%" />
        ) : (
          <UsersByCampusChart data={this.state.data} />
        )}
      </div>
    );
  }
}

function mapStateToProps(state) {
  const tenant = getTenantState(state);
  return { tenant };
}

export default connect(mapStateToProps, {
  getUsersByCampusCounts,
  getUsersByCampusCountsCsv,
})(UsersByCampus);
